import { useState, useEffect } from 'react';

import { fetchLatestVersion } from '@features/app-update/utils/fetch-latest-version';

const CHECK_INTERVAL_MS = 60 * 1000; // 1 minute

/**
 * Tells whether a newer build than the one currently running has been deployed.
 * Checked periodically and each time the tab becomes visible again.
 */
export const useAppUpdate = (): boolean => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  useEffect(() => {
    if (import.meta.env.DEV || updateAvailable) {
      return undefined;
    }

    const check = async () => {
      const latest = await fetchLatestVersion();

      if (latest && latest !== __APP_VERSION__) {
        setUpdateAvailable(true);
      }
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        check();
      }
    };

    const interval = window.setInterval(check, CHECK_INTERVAL_MS);
    document.addEventListener('visibilitychange', onVisibilityChange);

    return () => {
      window.clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisibilityChange);
    };
  }, [updateAvailable]);

  return updateAvailable;
};
